/* ==========================================================================
   Alternator Size Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-asc]');
  if (!root) return;

  var BASE = { basic: 35, modern: 60, loaded: 85 };
  /* Current needed to put charge back into the battery while everything else runs. */
  var CHARGE_RESERVE_A = 20;
  /* Headroom so the alternator is not pinned at 100% output continuously. */
  var HEADROOM = 1.25;
  /* Most alternators produce roughly 40% of rated output at engine idle. */
  var IDLE_FRACTION = 0.40;

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function compute(input) {
    var base = BASE[input.base] || BASE.modern;
    function n(v) { return isFinite(v) && v > 0 ? v : 0; }

    var audio = n(input.audio), lights = n(input.lights),
        winch = n(input.winch), other = n(input.other);

    /* A winch runs in short bursts off the battery rather than continuously,
       so only a share of its peak counts as sustained alternator load. */
    var winchSustained = winch * 0.35;

    var continuous = base + audio + lights + other;
    var withWinch = continuous + winchSustained;
    var required = withWinch + CHARGE_RESERVE_A;
    var recommended = required * HEADROOM;

    var status, warnings = [], figures = [
      { label: 'Alternator needed', value: Math.ceil(recommended / 10) * 10 + ' A',
        sub: comma(Math.round(required)) + 'A of real load plus 25% headroom.' }
    ];

    var rows = [
      { head: 'Load' },
      { label: 'Vehicle baseline', value: base + ' A' }
    ];
    if (audio)  rows.push({ label: 'Audio', value: num(audio, 0) + ' A' });
    if (lights) rows.push({ label: 'Auxiliary lighting', value: num(lights, 0) + ' A' });
    if (winch)  rows.push({ label: 'Winch, averaged', value: num(winchSustained, 0) + ' A  (peak ' + num(winch, 0) + ')' });
    if (other)  rows.push({ label: 'Other', value: num(other, 0) + ' A' });
    rows.push({ label: 'Continuous total', value: num(withWinch, 0) + ' A' });
    rows.push({ label: 'Battery charging', value: CHARGE_RESERVE_A + ' A' });
    rows.push({ label: 'Required', value: num(required, 0) + ' A' });
    rows.push({ label: 'With headroom', value: Math.ceil(recommended / 10) * 10 + ' A' });

    if (isFinite(input.have) && input.have > 0) {
      var idle = input.have * IDLE_FRACTION;
      rows.push({ head: 'Your alternator' });
      rows.push({ label: 'Rated', value: num(input.have, 0) + ' A' });
      rows.push({ label: 'Roughly at idle', value: num(idle, 0) + ' A' });
      rows.push({ label: 'Spare at cruise', value: num(input.have - required, 0) + ' A' });

      figures.push({ label: 'Spare capacity at cruise', value: signed(input.have - required, 0) + ' A',
        sub: 'Roughly ' + num(idle, 0) + 'A available at idle, against ' + num(withWinch, 0) + 'A of load.' });

      if (input.have < required) {
        status = { key: 'now', label: 'Not enough',
                   note: 'Load exceeds output even at cruise. The battery makes up the difference and slowly goes flat.' };
      } else if (idle < withWinch) {
        status = { key: 'soon', label: 'Short at idle',
                   note: 'Fine while driving, but at idle the alternator produces about ' + num(idle, 0)
                       + 'A against ' + num(withWinch, 0) + 'A of load. Sitting still with everything on will drain the battery.' };
      } else if (input.have < recommended) {
        status = { key: 'monitor', label: 'Adequate, no margin',
                   note: 'It covers the load but runs near capacity, which shortens alternator life.' };
      } else {
        status = { key: 'good', label: 'Comfortable',
                   note: num(input.have - required, 0) + 'A of spare capacity at cruise.' };
      }
    } else {
      status = { key: 'good', label: Math.ceil(recommended / 10) * 10 + ' A',
                 note: num(withWinch, 0) + 'A of continuous load plus charging and headroom.' };
    }

    if (winch > 0) {
      warnings.push('A winch draws far more than any alternator makes. It runs off the battery and the alternator recovers afterwards, so a second battery matters more than a bigger alternator for winching.');
    }

    return { ok: true, errors: [], warnings: warnings, status: status, figures: figures, rows: rows };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "base",
          "key": "b",
          "type": "select"
      },
      {
          "name": "audio",
          "key": "au",
          "type": "number"
      },
      {
          "name": "lights",
          "key": "li",
          "type": "number"
      },
      {
          "name": "winch",
          "key": "wi",
          "type": "number"
      },
      {
          "name": "other",
          "key": "ot",
          "type": "number"
      },
      {
          "name": "have",
          "key": "h",
          "type": "number"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-asc__figure">'
        + '<div class="pc-asc__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-asc__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-asc__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-asc__row pc-asc__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-asc__row">'
        + '<span class="pc-asc__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-asc__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_ASC = { compute: compute };
})();
